import { IS_DEVNET } from '@shared/utils/constant'
import { MainPage } from '@/types'

export default defineNuxtRouteMiddleware((to) => {
  const $pinia = usePinia()
  const sharedWalletStore = useSharedWalletStore($pinia)

  if (to.name !== MainPage.Auction && IS_DEVNET) {
    return navigateTo({ name: MainPage.Auction })
  }

  if (
    !IS_DEVNET &&
    to.name !== MainPage.Swap &&
    !sharedWalletStore.isUserConnected
  ) {
    return navigateTo({ name: MainPage.Swap })
  }
})
